(function () {
  'use strict';

  const { iman, BaseCarousel } = window.Universe;

  class CollectionCards {
    constructor(section, parent) {
      if (!section || !parent) return;
      this.init(section, parent);
    }

    setup() {
      const isMobileEnabled = this.DOM.section.dataset.mobileEnabled;
      const isDesktopEnabled = this.DOM.section.dataset.desktopEnabled;

      this.instance = new BaseCarousel({
        wrap: this.DOM.parent,
        carousel: this.DOM.section,
        carouselOptions: {
          align: 'start',
          dragFree: true,
          containScroll: 'trimSnaps',
          active: isDesktopEnabled === 'true',
          breakpoints: {
            '(max-width:768px)': { active: isMobileEnabled === 'true' }
          }
        },
        onReady: () => {
          if (this.DOM.prev.length) {
            for (let i = 0; i < this.DOM.prev.length; i++) {
              this.DOM.prev[i].addEventListener('click', this.onPrev);
            }
          }

          if (this.DOM.next.length) {
            for (let i = 0; i < this.DOM.next.length; i++) {
              this.DOM.next[i].addEventListener('click', this.onNext);
            }
          }

          this.setupCards();
        }
      });
    }

    setupCards() {}

    destroyCards() {}

    destroy() {
      if (this.DOM) {
        if (this.DOM.prev.length) {
          for (let i = 0; i < this.DOM.prev.length; i++) {
            this.DOM.prev[i].removeEventListener('click', this.onPrev);
          }
        }

        if (this.DOM.next.length) {
          for (let i = 0; i < this.DOM.next.length; i++) {
            this.DOM.next[i].removeEventListener('click', this.onNext);
          }
        }

        this.instance.destroy();
        this.destroyCards();

        this.instance = undefined;
        this.DOM = undefined;
      }
    }

    init(section, parent) {
      this.DOM = {};
      this.DOM.parent = parent;
      this.DOM.section = section;

      this.DOM.prev = this.DOM.parent.querySelectorAll('.js-carousel-prev');
      this.DOM.next = this.DOM.parent.querySelectorAll('.js-carousel-next');

      this.onPrev = () => {
        this.instance.instance.scrollPrev();
      };
      this.onNext = () => {
        this.instance.instance.scrollNext();
      };

      this.setup();
    }
  }

  class CollectionListSection {
    constructor(section) {
      this.init(section);
    }

    setup() {
      const cardsCarousel = new CollectionCards(this.DOM.carousel, this.DOM.parent);
      this.carousels.push(cardsCarousel);
    }

    destroy() {
      if (this.DOM) {
        if (this.carousels) {
          this.carousels.forEach((carousel) => { carousel.destroy(); });
        }
        this.carousels = [];
        this.DOM = undefined;
      }
    }

    init(section) {
      if (section) {
        this.DOM = {};
        this.DOM.parent = section;
        this.sectionId = this.DOM.parent.closest('.shopify-section')?.id || null;
        this.DOM.carousel = this.DOM.parent.querySelector('.js-collection-list-carousel');

        this.carousels = [];

        if (this.DOM.carousel) {
          this.setup();
        } else {
          console.warn('No carousel found in CollectionList');
        }
      }
    }
  }

  class CollectionList {
    constructor() {
      this.init();
    }

    setup() {
      for (let i = 0; i < this.DOM.sections.length; i++) {
        this.instances.push(new CollectionListSection(this.DOM.sections[i]));
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    reinitSection(sectionEl) {
      this.destroySection(sectionEl);
      if (!this.DOM) { this.DOM = {}; this.instances = []; }
      const newSections = sectionEl.querySelectorAll('.js-collection-list');
      for (let i = 0; i < newSections.length; i++) {
        this.instances.push(new CollectionListSection(newSections[i]));
      }
      this.DOM.sections = document.querySelectorAll('.js-collection-list');
    }

    destroySection(sectionEl) {
      if (!this.instances) return;
      const targetId = sectionEl.id || sectionEl.closest('.shopify-section')?.id;
      if (!targetId) return;
      for (let i = this.instances.length - 1; i >= 0; i--) {
        const item = this.instances[i];
        if (item.sectionId === targetId) {
          item.destroy();
          this.instances.splice(i, 1);
        }
      }
    }

    onBlockSelect(blockEl) {
      for (let i = 0; i < this.instances.length; i++) {
        const item = this.instances[i];
        if (item.DOM && item.DOM.parent && item.DOM.parent.contains(blockEl)) {
          const slide = blockEl.closest('.js-carousel-slide');
          if (!slide) break;

          const emblaApi = item.carousels && item.carousels[0] && item.carousels[0].instance ? item.carousels[0].instance.instance : null;
          if (emblaApi) {
            const slides = emblaApi.slideNodes();
            const slideIndex = Array.from(slides).indexOf(slide);
            if (slideIndex !== -1) {
              const autoplay = emblaApi.plugins().autoplay;
              if (autoplay) autoplay.stop();
              emblaApi.scrollTo(slideIndex);
            }
          }
          break;
        }
      }
    }

    onBlockDeselect(blockEl) {
      for (let i = 0; i < this.instances.length; i++) {
        const item = this.instances[i];
        if (item.DOM && item.DOM.parent && item.DOM.parent.contains(blockEl)) {
          const emblaApi = item.carousels && item.carousels[0] && item.carousels[0].instance ? item.carousels[0].instance.instance : null;
          if (emblaApi) {
            const autoplay = emblaApi.plugins().autoplay;
            if (autoplay) autoplay.play();
          }
          break;
        }
      }
    }

    destroy() {
      if (this.DOM) {
        for (let i = 0; i < this.instances.length; i++) {
          this.instances[i].destroy();
        }
        this.instances = [];
        this.DOM = undefined;
      }
    }

    init(container) {
      container = container || document;
      const sections = container.querySelectorAll('.js-collection-list');

      if (sections.length) {
        this.DOM = {};
        this.DOM.sections = sections;
        this.instances = [];
        this.setup();
      }
    }
  }

  function init() {
    if (!iman.get('collectionList')) {
      iman.add('collectionList', new CollectionList());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Universe.CollectionList = CollectionList;
})();
